import { CarvanaEmblem } from '@carvana/ds-icons';
import React from 'react';
import SlateFooter from '|/app/footer/slate-footer';
import { useSlate } from '|/context';
import styles from './checkout-footer.module.css';

const CheckoutFooter: React.FC = () => {
  const { isSlateVehicle } = useSlate();

  if (isSlateVehicle) return <SlateFooter />;

  return (
    <footer className={styles.footer}>
      <CarvanaEmblem className={styles.logo} />
      <p className={styles.copyright}>
        Copyright © {new Date().getFullYear()} Carvana, LLC. All Rights Reserved.
      </p>
    </footer>
  );
};

export default CheckoutFooter;
